import LeadContext from './LeadContext.component';

export default LeadContext;